import { Reveal, Eyebrow } from "@/components/Reveal";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="bg-cream-soft py-24 lg:py-36">
    <div className="mx-auto max-w-3xl px-6 lg:px-10">
      <Reveal className="text-center">
        <Eyebrow className="text-center">Frequently Asked Questions</Eyebrow>
        <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-navy sm:text-3xl lg:text-4xl">
          Everything you need to know about non-medical companionship
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="rounded-2xl border border-navy/[0.06] bg-white px-6 shadow-ambient transition-colors data-[state=open]:border-mauve/40"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-5 text-left font-serif text-base text-navy hover:no-underline sm:text-lg"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i + 1}`}
                className="pb-6 text-sm leading-relaxed text-charcoal/75"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
